import { Helmet } from "react-helmet-async";

/**
 * Reusable SEO component. Renders meta tags, Open Graph, Twitter cards
 * and optional JSON-LD structured data for the current page.
 */
export default function SEO({
  title,
  description,
  image,
  url,
  type = "website",
  keywords,
  jsonLd,
  noindex = false,
}) {
  const siteName = "Mad Brothers Bakery";
  const defaultImage = "https://cake-craft-studio-3.emergent.host/apple-touch-icon.png";
  const pageTitle = title ? `${title} | ${siteName}` : `${siteName} | Artisan Cakes in Dublin`;
  const pageUrl = url || (typeof window !== "undefined" ? window.location.href : "");
  const pageImage = image || defaultImage;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <link rel="canonical" href={pageUrl} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={pageImage} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:locale" content="en_IE" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={pageImage} />

      {/* Structured data (JSON-LD) */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}
